// extracted by mini-css-extract-plugin
export default {"container":"service_container__bNc6D","icon":"service_icon__S6fk8","content":"service_content__5NRy6"};